import { useRef, useState } from "react"
import { Paper, Typography } from "@mui/material"
import { CloudUpload as CloudUploadIcon } from "@mui/icons-material"

interface IProps {
  onFiles: (files: File[]) => void
  disabled?: boolean
}

/** Дропзона нескольких .zip с tdata (1 zip = 1 аккаунт). */
export const TdataDropzone = ({ onFiles, disabled = false }: IProps) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [dragOver, setDragOver] = useState(false)

  const handleFiles = (fileList: FileList | null) => {
    const zips = Array.from(fileList ?? []).filter((f) =>
      f.name.toLowerCase().endsWith(".zip"),
    )
    if (zips.length > 0) onFiles(zips)
  }

  return (
    <Paper
      variant="outlined"
      onDragOver={(e) => {
        e.preventDefault()
        if (!disabled) setDragOver(true)
      }}
      onDragLeave={() => setDragOver(false)}
      onDrop={(e) => {
        e.preventDefault()
        setDragOver(false)
        if (!disabled) handleFiles(e.dataTransfer.files)
      }}
      onClick={() => {
        if (!disabled) inputRef.current?.click()
      }}
      sx={{
        p: 3,
        textAlign: "center",
        cursor: disabled ? "default" : "pointer",
        borderStyle: "dashed",
        borderColor: dragOver ? "primary.main" : "divider",
        bgcolor: dragOver ? "action.hover" : "transparent",
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <input
        ref={inputRef}
        type="file"
        accept=".zip"
        multiple
        hidden
        aria-label="Zip-архивы с tdata"
        onChange={(e) => {
          handleFiles(e.target.files)
          e.target.value = "" // повторный выбор того же файла
        }}
      />
      <CloudUploadIcon color={dragOver ? "primary" : "action"} />
      <Typography variant="body2" sx={{ mt: 1 }}>
        Перетащите .zip архивы с tdata или нажмите для выбора
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Один архив = один аккаунт
      </Typography>
    </Paper>
  )
}
